export default __webpack_public_path__ + "static/0157-3f3fe9caca9b3efb06bd285b4a174cc8.png";